/* Le Peigne de Vivi — scroll film
   Smooth scrubbing: Blob-backed sources (no network stalls mid-scroll) +
   seek coalescing (never issue a new seek before the last one painted). */
(function () {
  var root = document.querySelector("[data-vv-scrub]");
  if (!root) return;
  var reduce = window.matchMedia("(prefers-reduced-motion: reduce)").matches;
  var stage = root.querySelector(".vv-scrub__stage");
  var chapters = [].slice.call(root.querySelectorAll(".vv-chapter"));
  var videos = [].slice.call(stage.querySelectorAll("video"));
  var posters = [].slice.call(stage.querySelectorAll("img.vv-scrub__poster"));
  if (reduce || !videos.length) {
    if (posters[0]) posters[0].classList.add("is-active");
    videos.forEach(function (v) { v.remove(); });
    return;
  }
  var mobile = window.matchMedia("(max-width: 860px), (hover: none) and (pointer: coarse)").matches;

  var state = videos.map(function (v) {
    return { el: v, ready: false, seekBusy: false, target: 0, current: 0 };
  });

  function loadClip(s) {
    var v = s.el;
    var src = mobile && v.dataset.mobileSrc ? v.dataset.mobileSrc : v.dataset.src;
    fetch(src)
      .then(function (r) { return r.blob(); })
      .then(function (blob) {
        v.src = URL.createObjectURL(blob);
        v.muted = true;
        v.preload = "auto";
        v.setAttribute("playsinline", "");
        v.addEventListener("loadeddata", function () {
          s.ready = true;
          var i = state.indexOf(s);
          if (i === active && posters[i]) posters[i].classList.remove("is-active");
        }, { once: true });
        v.addEventListener("seeked", function () {
          s.seekBusy = false;
        });
        v.load();
      })
      .catch(function () { /* poster stays */ });
  }
  state.forEach(loadClip);

  var primed = false;
  function prime() {
    if (primed) return;
    primed = true;
    state.forEach(function (s) {
      var p = s.el.play();
      if (p && p.then) p.then(function () { s.el.pause(); }).catch(function () {});
    });
  }
  window.addEventListener("touchstart", prime, { once: true, passive: true });
  window.addEventListener("pointerdown", prime, { once: true, passive: true });

  var active = -1;
  function setActive(i) {
    if (i === active) return;
    active = i;
    state.forEach(function (s, k) {
      s.el.classList.toggle("is-active", k === i);
    });
    posters.forEach(function (p, k) {
      p.classList.toggle("is-active", k === i && !state[k].ready);
    });
  }

  function requestSeek(s) {
    if (!s.ready || s.seekBusy) return;
    var v = s.el;
    if (!v.duration) return;
    var t = Math.min(s.target, v.duration - 0.05);
    if (Math.abs(v.currentTime - t) < 0.02) return;
    s.seekBusy = true;
    try {
      v.currentTime = t;
    } catch (e) {
      s.seekBusy = false;
    }
  }

  function tick() {
    var vh = window.innerHeight;
    for (var i = 0; i < chapters.length; i++) {
      var r = chapters[i].getBoundingClientRect();
      if (r.top <= 0 && r.bottom > 0) {
        var progress = Math.min(1, Math.max(0, -r.top / (r.height - vh)));
        setActive(i);
        var s = state[i];
        if (s && s.el.duration) {
          // ease toward the scroll target so fast flicks stay smooth
          var goal = progress * s.el.duration;
          s.current = s.current + (goal - s.current) * 0.35;
          s.target = s.current;
          requestSeek(s);
        }
        break;
      }
    }
    requestAnimationFrame(tick);
  }
  setActive(0);
  posters.forEach(function (p, k) { p.classList.toggle("is-active", k === 0); });
  requestAnimationFrame(tick);
})();
